import { Menu, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'

export const MenuWrapper = styled(Menu)(({ theme }) => ({
  backgroundColor: theme.palette.background.popup.paper,
  backdropFilter: 'blur(2px)',
  padding: '20px',
  overflow: 'visible',
  borderRadius: '0px',

  //Menu items container - Surrounds MenuItemsContainer
  '& .MuiList-root': {
    padding: '0px',
    borderRadius: `0px`,
    overflow: 'visible',
  },
  '& .MuiPaper-root': {
    padding: '0px',
    borderRadius: `0 0 ${theme.shape.customBorderRadius.wrapperMedium} ${theme.shape.customBorderRadius.wrapperMedium}`,
    boxShadow: theme.shadows[2],
    overflow: 'visible',
  },
}))

//Menu items container - Flat top
export const MenuItemsContainer = styled(Paper)(({ theme }) => ({
  border: theme.palette.background.popup.border,
  borderTop: theme.palette.background.popup.borderTop,
  backgroundColor: theme.palette.background.popup.backgroundColor,

  overflow: 'visible',

  //Each menu item-wrapper
  '& .MuiMenuItem-root': {
    '&:hover': {
      backgroundColor: theme.palette.background.popup.hoverBackgroundColor,
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
}))

//Single menu item wrapper
export const MenuItemWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const IconWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color, theme }) => ({
  '& svg': {
    paddingTop: 2,
    color: color ?? theme.palette.primary.main,
    fontSize: 22,
    marginRight: 10,
  },
}))

export const LabelWrapper = styled('div')({
  fontSize: 15,
})
